module.exports = __webpack_public_path__ + "img/circle.47df98d9.png";